import api from './axios';

export async function listCompanyValues(cycleId, perPage = 1000) {
    const { data } = await api.get('/api/company-values', {
        params: { cycle_id: cycleId, per_page: perPage },
    });
    // controller returns a paginator
    return data?.data ?? [];
}

export async function createCompanyValue(payload) {
    const { data } = await api.post('/api/company-values', payload);
    return data;
}

export async function updateCompanyValue(id, patch) {
    const { data } = await api.patch(`/api/company-values/${id}`, patch);
    return data;
}

export async function deleteCompanyValue(id) {
    await api.delete(`/api/company-values/${id}`);
    return true;
}
